// Admin settings 2FA helpers. Tokens viven en cookies HttpOnly del backend.
import { api } from "./api";

export const settingsApi = {
  request: () => api.post("/admin/2fa/request"),
  verify: (code) => api.post("/admin/2fa/verify", { code }),
  status: () => api.get("/admin/2fa/status"),
  lock: () => api.post("/admin/2fa/lock"),
};

// Las llamadas autenticadas a settings van con la cookie sc_settings (httpOnly)
// vía withCredentials en axios. No se necesita Bearer manual.
export const settingsRequest = (method, path, body) => {
  return api.request({ method, url: path, data: body });
};
